import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import CreatorsPage from './creators-slides/index';
import AgencyPage from './agency-slides';
import { withWidth } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const selectNavigateBackLocation = (state) => state.navigateBackLocation;

function LandingPageLayout({ width, initialSection }) {
  const [index, setIndex] = useState(initialSection === 'creator-agency' ? 1 : 0);

  // Update index when route changes
  useEffect(() => {
    if (initialSection === 'creator-agency') {
      setIndex(1);
    } else if (initialSection === 'creator' || initialSection === 'waitlist' || !initialSection) {
      setIndex(0);
    }
  }, [initialSection]);

  // Handle section navigation
  useEffect(() => {
    const handleSectionNavigation = () => {
      if (initialSection) {
        switch (initialSection) {
          case 'creator':
            const creatorElement = document.getElementById('LandingPage1');
            if (creatorElement) {
              setIndex(0);
              // creatorElement.scrollIntoView({ behavior: 'smooth' });
            }
            break;
          case 'creator-agency':
            const agencyElement = document.getElementById('AgencyPage');
            if (agencyElement) {
              setIndex(1);
              // agencyElement.scrollIntoView({ behavior: 'smooth' });
            }
            break;
          case 'waitlist':
            // Always show creator waitlist for /waitlist URL
            setTimeout(() => {
              const creatorElement = document.getElementById('LandingPage1');
              if (creatorElement) {
                creatorElement.scrollTo({
                  top: creatorElement.scrollHeight - window.innerHeight * 2,
                  behavior: 'smooth'
                });
              }
            }, 100);
            break;
          default:
            break;
        }
      }
    };

    handleSectionNavigation();
  }, [initialSection]);

  return (
    <Box>
      <SwipeableViews index={index} onChangeIndex={setIndex}>
        <Box sx={{ height: '100vh', width: '100vw' }}>
          <CreatorsPage setIndex={setIndex} />
        </Box>
        <Box sx={{ height: '100vh', width: '100vw' }}>
          <AgencyPage isPhone={width === 'xs'} setIndex={setIndex} />
        </Box>
      </SwipeableViews>
    </Box>
  );
}

export default withWidth()(LandingPageLayout);
